// removed by extract-text-webpack-plugin
module.exports = {"container":"location_location-popover_container","popover":"location_location-popover_popover","button":"location_location-popover_button"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/location-widget/src/components/location-popover/style.less
// module id = 1150
// module chunks = 1